<template>
  <el-popover
    placement="right"
    :width="236"
    trigger="hover"
    popper-class="appointment-popover"
  >
    <template #reference>
      <slot />
    </template>
    <div v-if="appointment">
      <div class="popover-main">
        <div class="popover-title">
          <template v-if="appointment.client_name">
            {{ appointment.client_name }}
          </template>
          <template v-else>
            <span style="color: var(--cal-danger);">Клиент удалён</span>
          </template>
        </div>
        <div class="popover-phone">
          <template v-if="appointment.client_phone">
            {{ appointment.client_phone }}
          </template>
          <template v-else>
            <span style="color: var(--ui-color-text-disabled);">—</span>
          </template>
        </div>
        <div class="popover-services">
          <span v-for="srv in appointment.services" :key="srv.id">
            {{ srv.name }} <span v-if="srv.duration">({{ srv.duration }} мин)</span>
            <span v-if="!srv.last">, </span>
          </span>
        </div>
        <div class="popover-times">{{ appointment.start_time }}-{{ calcEnd }}</div>
        <div class="popover-status" :class="statusClass">{{ statusLabel }}</div>
      </div>
    </div>
  </el-popover>
</template>

<script>
export default {
  name: 'AppointmentPopover',
  props: {
    appointment: { type: Object, required: true }
  },
  computed: {
    calcEnd() {
      const t = this.timeToMin(this.appointment.start_time)
      const duration = this.appointment.duration_time ||
        (this.appointment.services || []).reduce((s, x) => s + (x.duration || 0), 0)
      return this.formatTime(t + duration)
    },
    statusClass() {
      const st = this.appointment.status
      if (st) return `status-${st}`
      return `status-${this.getStatus(this.appointment)}`
    },
    statusLabel() {
      const STATUS_LABELS = {
        planned: 'Запланировано',
        confirmed: 'Подтверждено',
        done: 'Выполнено',
        no_show: 'Не пришёл',
        canceled: 'Отменено'
      }
      const st = this.appointment.status
      return STATUS_LABELS[st] || 'Статус не определён'
    }
  },
  methods: {
    timeToMin(str) {
      if (!str) return 0
      const [h, m] = str.split(':').map(Number)
      return h * 60 + m
    },
    formatTime(t) {
      const h = Math.floor(t / 60)
      const m = t % 60
      return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`
    },
    getStatus(app) {
      const now = new Date()
      const today = now.toISOString().slice(0, 10)
      const start = this.timeToMin(app.start_time)
      const duration = app.duration_time ||
        (app.services || []).reduce((sum, s) => sum + (s.duration || 0), 0)
      const end = start + duration
      const curr = now.getHours() * 60 + now.getMinutes()
      if (app.date < today || (app.date === today && end <= curr)) return 'past'
      if (app.date === today && start <= curr && curr < end) return 'current'
      return 'future'
    }
  }
}
</script>

<style>
.appointment-popover.el-popover.el-popper {
  --el-popover-bg-color: #0d2248;
  --el-popover-border-color: rgba(32, 61, 113, 0.88);
  font-size: 14px;
  padding: 14px 16px 12px;
  background-color: #0d2248 !important;
  background-image: var(--cal-bg-popover) !important;
  color: var(--cal-text-popover) !important;
  border: 1px solid rgba(32, 61, 113, 0.88) !important;
  border-radius: 4px;
  box-shadow: var(--cal-shadow-popover) !important;
  font-family: var(--ui-font-family-base);
}

.appointment-popover.el-popper .el-popper__arrow::before {
  background-color: #0d2248;
  background-image: var(--cal-bg-popover);
  border-color: rgba(32, 61, 113, 0.88);
}

.appointment-popover .popover-main {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.appointment-popover .popover-title {
  font-weight: 500;
  color: #ffffff;
  font-size: 15px;
  line-height: 1.1;
  margin-bottom: 4px;
}

.appointment-popover .popover-phone {
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 4px;
}

.appointment-popover .popover-services,
.appointment-popover .popover-times {
  color: #00c3fe;
  font-size: 12px;
  line-height: 1.15;
  margin-bottom: 3px;
  font-weight: 600;
}

.appointment-popover .popover-status {
  font-size: 16px;
  margin-top: 6px;
  color: #000713;
  font-weight: 500;
}

.appointment-popover .popover-status.past {
  color: rgba(0, 7, 19, 0.78);
}

.appointment-popover .popover-status.current {
  color: #ffffff;
}

.appointment-popover .popover-status.future {
  color: #000713;
}

.appointment-popover .popover-status.status-planned { color: #000713; }
.appointment-popover .popover-status.status-confirmed { color: #ffffff; }
.appointment-popover .popover-status.status-done { color: #8ff4bb; }
.appointment-popover .popover-status.status-no_show { color: #ff9898; }
.appointment-popover .popover-status.status-canceled { color: rgba(0, 7, 19, 0.78); }
</style>
